import { CAROUSEL_DEVICES } from 'vio-constants';
export function calculateCarouselRotationReadiness(carouselState) {
    const { errors, stateMachineCode, statusRegister, vfdErrorCode } = carouselState;
    return (!errors || Object.keys(errors).length < 1) && stateMachineCode === 1 && statusRegister === 0 && vfdErrorCode === 0;
}
export function calculateCarouselState(devices) {
    const { CAROUSEL_GET_RACK_POSITION, CAROUSEL_ROTATE, CAROUSEL_SET_RACK_POSITION, CAROUSEL_STATE_MACHINE_CODE, CAROUSEL_STATUS_REGISTER, CAROUSEL_VFD_ERROR_CODE } = CAROUSEL_DEVICES;
    const carouselState = {
        currentPosition: -1,
        errors: undefined,
        lastSetPosition: -1,
        readiness: false,
        rotationDeviceId: undefined,
        stateMachineCode: -1,
        statusRegister: -1,
        vfdErrorCode: -1
    };
    const deviceTypes = ['json', 'status'];
    if (!devices) {
        return carouselState;
    }
    for (let i = 0; i < devices.length; i += 1) {
        const { device_type, id, info, status } = devices[i];
        if (!status || status.length < 1 || !deviceTypes.includes(device_type)) {
            continue;
        }
        const { value } = status.find(deviceStatus => {
            return deviceTypes.includes(deviceStatus.type);
        });
        if (info === CAROUSEL_ROTATE) {
            const { errors, status: carouselStatus } = value && JSON.parse(value);
            if (carouselStatus !== 'ok') {
                carouselState.errors = errors;
            }
            carouselState.rotationDeviceId = id;
        }
        else if (info === CAROUSEL_GET_RACK_POSITION) {
            carouselState.currentPosition = value;
        }
        else if (info === CAROUSEL_SET_RACK_POSITION) {
            carouselState.lastSetPosition = value;
        }
        else if (info === CAROUSEL_STATE_MACHINE_CODE) {
            carouselState.stateMachineCode = value;
        }
        else if (info === CAROUSEL_STATUS_REGISTER) {
            carouselState.statusRegister = value;
        }
        else if (info === CAROUSEL_VFD_ERROR_CODE) {
            carouselState.vfdErrorCode = value;
        }
        else {
            continue;
        }
    }
    carouselState.readiness = calculateCarouselRotationReadiness(carouselState);
    return carouselState;
}
